<template>
    <div class="svg-container-outer">
        <LoadingData v-if="loadingDespatch" :headerMessage="'Loading Optimization'"/>
        <div class="route-info">
            <div class="route-info-inner">
                <h3 class="manifest-header">Optimized Manifest</h3>
                <h3 class="manifest-header">Route {{selectedRoute}}</h3>
            </div>
            
            <div class="button-container-main">
                <div class="button-container-inner">
                    <button class="print-button" @click="reOpenManifest()">Re-Open Manifest</button>
                    <div v-if="(selectedRoute != '') && (manifestMapData.length > 0) && (manifestedSuccessfully == false)">
                        <button class="print-button bottom-button" @click="createStopsPdf()">Generate PDF</button>
                    </div>
                </div>
            </div>
        </div>
        <div v-for="(item, i) in manifestMapData" :key="i">
            <div class="time-distance" v-if="item.waypoint === '*'">
                <div class="time-distance-inner">
                    <p class="label">Time:</p>
                    <p class="value">{{ formatLocalTimeRange(item.startTime, item.endTime) }}</p>
                </div>
                <div class="time-distance-inner">
                    <p class="label">Duration:</p>
                    <p class="value">{{ formatHours(item.totalTime) }} hours</p>
                </div>
                <div class="time-distance-inner">
                    <p class="label">Distance:</p>
                    <p class="value">{{ formatMiles(item.totalDistance) }} miles</p>
                </div>
            </div>
        </div>
        <div v-if="(selectedRoute != '') && (manifestMapData.length > 0)"  class="svg-container">
            <div class="svg-inner-container">
                <p>Delivery</p>
                <svg xmlns="http://www.w3.org/2000/svg" overflow="visible" width="15" height="25" viewBox="0 0 24 32">
                    <g transform="translate(1.75, 28.0)" fill="#000000"><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="10.5" ry="5.25002273"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="10.5" ry="5.25002273"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="9.5" ry="4.77275007"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="8.5" ry="4.29549936"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="7.5" ry="3.81822308"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="6.5" ry="3.34094679"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="5.5" ry="2.86367051"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="4.5" ry="2.38636864"></ellipse></g>
                    <path stroke="#000" stroke-width="1" fill="#32ccfe" d="M12,0c-6.6,0-12,5.4-12,12c0,10,12,20,12,20s12-10,12-20C24,5.4,18.6,0,12,0z M12,15c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S13.7,15,12,15z"/>
                    <circle cx="12" cy="12" r="10.5" fill="#32ccfe"/>
                    <text x="50%" y="45%" text-anchor="middle" fill="#FFFFFF" font-size="12" dy=".3em" font-weight = "bold">1</text>
                </svg>
            </div>
            <div class="svg-inner-container">
                <p>Pickup</p>
                <svg xmlns="http://www.w3.org/2000/svg" overflow="visible" width="15" height="25" viewBox="0 0 24 32">
                    <g transform="translate(1.75, 28.0)" fill="#000000"><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="10.5" ry="5.25002273"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="10.5" ry="5.25002273"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="9.5" ry="4.77275007"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="8.5" ry="4.29549936"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="7.5" ry="3.81822308"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="6.5" ry="3.34094679"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="5.5" ry="2.86367051"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="4.5" ry="2.38636864"></ellipse></g>
                    <path stroke="#000" stroke-width="1" fill="#33f18a" d="M12,0c-6.6,0-12,5.4-12,12c0,10,12,20,12,20s12-10,12-20C24,5.4,18.6,0,12,0z M12,15c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S13.7,15,12,15z"/>
                    <circle cx="12" cy="12" r="10.5" fill="#33f18a"/>
                    <text x="50%" y="45%" text-anchor="middle" fill="#FFFFFF" font-size="12" dy=".3em" font-weight = "bold">2</text>
                </svg>
            </div>
            <div class="svg-inner-container">
                <p>Depot</p>
                <svg xmlns="http://www.w3.org/2000/svg" overflow="visible" width="15" height="25" viewBox="0 0 24 32">
                    <g transform="translate(1.75, 28.0)" fill="#000000"><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="10.5" ry="5.25002273"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="10.5" ry="5.25002273"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="9.5" ry="4.77275007"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="8.5" ry="4.29549936"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="7.5" ry="3.81822308"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="6.5" ry="3.34094679"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="5.5" ry="2.86367051"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="4.5" ry="2.38636864"></ellipse></g>
                    <path stroke="#000" stroke-width="1" fill="#fe804d" d="M12,0c-6.6,0-12,5.4-12,12c0,10,12,20,12,20s12-10,12-20C24,5.4,18.6,0,12,0z M12,15c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S13.7,15,12,15z"/>
                    <circle cx="12" cy="12" r="10.5" fill="#fe804d"/>
                    <text x="50%" y="45%" text-anchor="middle" fill="#FFFFFF" font-size="12" dy=".3em" font-weight = "bold">3</text>
                </svg>
            </div>
            <!-- <div class="svg-inner-container">
                <p>Break</p>
                <svg xmlns="http://www.w3.org/2000/svg" overflow="visible" width="15" height="25" viewBox="0 0 24 32">
                    <g transform="translate(1.75, 28.0)" fill="#000000"><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="10.5" ry="5.25002273"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="10.5" ry="5.25002273"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="9.5" ry="4.77275007"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="8.5" ry="4.29549936"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="7.5" ry="3.81822308"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="6.5" ry="3.34094679"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="5.5" ry="2.86367051"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="4.5" ry="2.38636864"></ellipse></g>
                    <path stroke="#000" stroke-width="1" fill="#000000" d="M12,0c-6.6,0-12,5.4-12,12c0,10,12,20,12,20s12-10,12-20C24,5.4,18.6,0,12,0z M12,15c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S13.7,15,12,15z"/>
                    <circle cx="12" cy="12" r="10.5" fill="#000000"/>
                    <text x="50%" y="45%" text-anchor="middle" fill="#FFFFFF" font-size="12" dy=".3em" font-weight = "bold">4</text>
                </svg>
            </div> -->
        </div>
        <div v-if="(selectedRoute != '') && (manifestMapData.length > 0) && (manifestedSuccessfully == false)" class="button-container">
            <button class="refresh-button" @click="refreshMap()">Refresh</button>
        </div>
        <div v-if="(selectedRoute != '') && (manifestMapData.length > 0) && (manifestedSuccessfully == false)" class="button-container">
            <button @click="manifestCreateTripFunc()" class="optimize-manifest-button">Dispatch</button>
        </div>

        <div  v-if="manifestedSuccessfully" class="despatch-info-container">
            <div class="manifest-text-container">
                <h3>Route {{selectedRoute}}</h3>
            </div>
            <div class="manifest-text-container">
                <p>{{manifestMapData.length}} shipments dispatched.</p>
            </div>
            <div class="manifest-text-container"> 
                <h3>LREX Trip Sheet ID: {{manifestTripSheetID}}</h3>
            </div>
        </div>
    </div>
  <div v-if="(selectedRoute != '') && (manifestMapData.length > 0)" ref="awsmap" id="map" />
  <loading-skeleton :loadingHeight="'50vh'" v-if="loadingManifestData"/>
  <shipment-info v-if="toggleTrackShipment" @closeShipmentInfo="closeShipmentInfo($event)" :cognitoUser="user" :trackShipmentID="popUpSelectedShipmentID"/>

  <div v-if="showDragAddressSuggestion" class="alert-container">
      <div class="inner-container">
          <div class="text-container">
            <div class="header-outer-container">
                <div class="header-container">
                    <svg style="width: 15px;
                    height: 15px;
                    padding-right: 5px;" id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 251.67 328.54" data-v-13454f0d=""><g id="_Ñëîé_1" data-name="Ñëîé 1" data-v-13454f0d=""><g data-v-13454f0d=""><g data-v-13454f0d=""><polyline class="cls-2-alt" points="213.95 310.25 213.95 280.72 192.99 240.34 66.07 240.34 45.11 284.23 45.11 310.25" data-v-13454f0d=""></polyline><line class="cls-2-alt" x1="48.63" y1="284.23" x2="213.95" y2="284.23" data-v-13454f0d=""></line><polyline class="cls-2-alt" points="150.64 284.23 150.64 323.54 129.53 314.13 108.43 323.54 108.43 284.23" data-v-13454f0d=""></polyline><line class="cls-2-alt" x1="115.46" y1="240.34" x2="108.43" y2="284.23" data-v-13454f0d=""></line><line class="cls-2-alt" x1="150.64" y1="284.23" x2="143.6" y2="240.34" data-v-13454f0d=""></line></g><path class="cls-2" d="M5,263.23l4.07-31.12c1.49-11.39,9.48-20.87,20.45-24.26l41.72-12.89c4.68-1.45,9.78-.46,13.58,2.62h0c23.9,19.38,58.11,19.38,82.01,0h0c3.81-3.09,8.9-4.07,13.58-2.62l41.72,12.89c10.97,3.39,18.97,12.87,20.45,24.26l4.07,31.12" data-v-13454f0d=""></path><path class="cls-2" d="M179.67,133.69v1.49c0,17.17-9.99,32.77-25.58,39.95l-16.31,7.52c-7.79,3.59-16.76,3.59-24.54,0l-16.31-7.52c-15.59-7.18-25.58-22.78-25.58-39.95v-1.49" data-v-13454f0d=""></path><path class="cls-2" d="M66.66,77.38l2.08-34.12c.68-11.22,7.8-21.02,18.25-25.15l28.02-11.08c6.83-2.7,14.44-2.7,21.28,0l28.02,11.08c10.45,4.13,17.56,13.94,18.25,25.15l2.08,34.12" data-v-13454f0d=""></path><path class="cls-2" d="M182.17,75.94l-.69-.59c-31.61-27.16-78.16-27.68-110.37-1.23l-1.41,1.16c-5.33,4.37-6.62,12-3.03,17.89l8.7,14.27h0c30.19-23.72,72.69-23.72,102.89,0h0s3.95-8.06,7.32-14.94c2.77-5.66,1.38-12.46-3.4-16.56Z" data-v-13454f0d=""></path><path class="cls-2" d="M57.76,116.69l-.15,.9c-1.37,8.44,5.15,16.11,13.7,16.11h.03" data-v-13454f0d=""></path><path class="cls-2" d="M193.24,116.69l.15,.9c1.37,8.44-5.15,16.11-13.7,16.11h0" data-v-13454f0d=""></path></g></g></svg>
                    <h3 style="margin: 0">{{popUpSelectedShipmentID}}</h3>
                </div>  
            </div>
            
            <p>{{autoCompleteData[0].Place.Label}}</p>
            <button class="cancel-button" @click="closeAddressSuggestion()">Cancel</button>
          </div>
      </div>
  </div>

  <div v-if="(selectedRoute != '') && (manifestMapData.length > 0)" class="svg-container">
    <!-- <select required name="Delivery Type" id="Delivery Type" v-model="manifestTableFilterValue" @change="filterManifestMapData">
        <option value="Priority">Priority</option>
        <option value="Delivery">Delivery</option>
        <option value="Pickup">Pickup</option>
        <option value="All">All</option>
    </select> -->
    <manifest-waypoint-table :cognitoUser="user" :userData="userData" :filterByRouteCode="selectedRoute"/>
  </div>

  <AlertUser v-if="toggleAlertBox" @closeAlertBox="closeAlertBox($event)" :message="alertMessage"/> 
</template>

<script>
import { Auth, Signer, API } from 'aws-amplify'
import Location from "aws-sdk/clients/location";
import maplibregl from 'maplibre-gl'
import AWS from '../../aws-exports'
import 'maplibre-gl/dist/maplibre-gl.css';
import ShipmentInfo from '../ShipmentDashboard/ShipmentInfo.vue'
import LoadingSkeleton from '../ShipmentDashboard/LoadingSkeleton.vue'
import AlertUser from '../Popups/AlertUser.vue';
import LoadingData from '../../components/Popups/LoadingData.vue';
import { PDFDocument, StandardFonts } from 'pdf-lib'
import bwipjs from 'bwip-js';
import ManifestWaypointTable from '../ShipmentDashboard/ManifestDashboard/ManifestWaypointTable.vue';

export default {
    data(){
        return{
            toggleTrackShipment: false,
            manifestTripSheetID: null,
            manifestedSuccessfully: false,
            showDragAddressSuggestion: false,
            loadingDespatch: false,
            newLatitude: "",
            newLongitude: "",
            autoCompleteData: [],
            credentials: null,
            user: {},
            mapCenter: [],
            popUpSelectedShipmentID: "",
            manifestMapData: [],
            selectedRoute: "",
            toggleAlertBox: false,
            alertMessage: "",
            loadingManifestData: false,
            routeTableData: [],
            selectedRouteObject: {},
            // manifestTableFilterValue: "",
            // manifestTableTemporaryData: []
        }
    },
    components:{
        ShipmentInfo,
        LoadingSkeleton,
        AlertUser,
        LoadingData,
        ManifestWaypointTable
    },
    props:['showPickupLogic', 'routeData'],
    mounted: async function () {
        this.credentials = await Auth.currentCredentials()

        Auth.currentAuthenticatedUser().then(user => {
            this.user = user;
            this.listRouteData();
        }).catch(error => {
          if(error){
            this.$router.push('Login');
            Auth.signOut({global: false})
          }
        });
        this.selectedRoute = this.routeData.routeCode;
        this.selectedRouteObject = this.routeData;
        await this.getManifestShipmentData()
        await this.getRouteData();
        if(this.manifestMapData.length > 0){
            if((this.manifestMapData[0].longitude != "")){
                this.mapCreate();
            }
        }else{
            this.toggleAlertBox = true;
            this.alertMessage = "No manifest data available";
            this.selectedRoute = "";
        }
    },
    unmounted(){
        //Reset hash allow map to adjust to address changes
        window.location.hash = ""
    },
    methods:{
        formatLocalTime(timeStr) {
            if (!timeStr) return "";

            const [hours, minutes] = timeStr.split(":").map(Number);
            const date = new Date();
            date.setHours(hours, minutes, 0, 0);

            return date.toLocaleTimeString(undefined, {
                hour: "numeric",
                minute: "2-digit",
                hour12: true
            });
        },

        formatLocalTimeRange(start, end) {
            if (!start || !end) return "";
            return `${this.formatLocalTime(start)} – ${this.formatLocalTime(end)}`;
        },
        formatHours(totalMinutes) {
            if (!totalMinutes) return "0.0";
            return (totalMinutes / 60).toFixed(1);
        },
        formatMiles(distance) {
            if (!distance) return "0.0";
            return Number(distance).toFixed(1);
        },
        // async filterManifestMapData(){
        //     console.log(this.manifestTableFilterValue)
        //     console.log(this.tripShipments)
        //     this.manifestTableTemporaryData = this.tripShipments;
            
        //     if(this.manifestTableFilterValue == "Delivery"){
        //         this.manifestTableTemporaryData = this.tripShipments.filter(item => (item?.isDelivery === true));
        //     }else if(this.manifestTableFilterValue == "Pickup"){
        //         this.manifestTableTemporaryData = this.tripShipments.filter(item => item?.isDelivery === false);
        //     }else if(this.manifestTableFilterValue == "All"){
        //         this.manifestTableTemporaryData = this.tripShipments;
        //     }
        // },
        async reOpenManifest(){

            let updateRouteTable = `mutation updateRoute{
            updateRoute(input: {routeCode: "${this.selectedRoute}", manifestStatus: "Despatched"}) {
                    routeCode
                    openManifestAction
                    routeId
                    manifestCutoffTime
                }
            }
            `

            try{
                let updateRouteTableData = await API.graphql({
                query:  updateRouteTable,
                authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                console.log("Route Data: ", updateRouteTableData.data);
                this.toggleAlertBox = true;
                this.alertMessage = "Route status updated"
                this.$emit('toggleOpenManifestMap', {showOpenManifest: true})
            }catch(e){
                console.log(e)
                if(e){
                    this.toggleAlertBox = true;
                    this.alertMessage = "Error getting route data"
                }
            }
        },
        async makePdf417PngBytes(text) {
            const canvas = document.createElement('canvas');
            await bwipjs.toCanvas(canvas, {
                bcid: 'pdf417',
                text: String(text),
                scale: 2,
                height: 10,
                includetext: false,
                columns: 6,
            });

            const blob = await new Promise(res => canvas.toBlob(res, 'image/png'));
            const ab = await blob.arrayBuffer();
            return new Uint8Array(ab);
        },
        async createStopsPdf() {
            let stops = this.manifestMapData;
            const sorted = [...stops].sort((a, b) => (a.stop ?? 0) - (b.stop ?? 0));

            // Setup doc + fonts
            const pdf = await PDFDocument.create();
            let page = pdf.addPage();
            const font = await pdf.embedFont(StandardFonts.Helvetica);
            const fontBold = await pdf.embedFont(StandardFonts.HelveticaBold);

            // Layout
            const margin = 50;
            const lineH = 16;
            let y = page.getHeight() - margin;

            // Adds new page as needed
            const line = (text, { bold=false, size=12 } = {}) => {
                if (y < margin + lineH) {
                page = pdf.addPage();
                y = page.getHeight() - margin;
                }
                page.drawText(text, { x: margin, y: y - lineH, size, font: bold ? fontBold : font });
                y -= lineH;
            };

            for (const s of sorted) {
                if(s.waypoint == "*"){
                    const toLocalTime = t => {
                    const [h, m] = t.split(':');
                    const d = new Date();
                        d.setHours(h, m);
                        return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
                    };

                    const time = [s.startTime, s.endTime]
                    .filter(Boolean)
                    .map(toLocalTime)
                    .join(' – ');

                    line('LREX ' + s.created + ' Route ' + s.route + ' ( ' + time + ' )', { bold: true, size: 12 });
                    y -= 6;
                }

                if (s.waypoint === "*" && s.totalDistance && s.totalTime) {
                    const totalTime = Number(s.totalTime / 60).toFixed(2);
                    const totalDistance = Number(s.totalDistance).toFixed(2);

                    const timeText = `Total Time: ${totalTime} hours`;
                    const distText = `Total Miles: ${totalDistance}`;
                    const fontSize = 12;

                    // Measure width of right-side text to align it properly
                    const rightTextWidth = font.widthOfTextAtSize(distText, fontSize);

                    // Left side
                    const leftX = margin;
                    const rightX = page.getWidth() - margin - rightTextWidth;

                    page.drawText(timeText, { x: leftX, y: y - lineH, size: fontSize, font });
                    page.drawText(distText, { x: rightX, y: y - lineH, size: fontSize, font });

                    y -= lineH + 6;
                }
                const width = page.getWidth();
                page.drawLine({
                    start: { x: 50, y },
                    end:   { x: width - 50, y },
                    thickness: 1,
                    dashPhase: 0,
                });
                const header = Number.isFinite(s.stop) ? `Stop ${s.stop}` : 'Stop';
                const toLocalTime = t => {
                    const [h, m] = t.split(':');
                    const d = new Date();
                    d.setHours(h, m);
                    return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
                };

                const time = [s.windowStart, s.windowEnd]
                .filter(Boolean)
                .map(toLocalTime)
                .join(' – ');

                const arrivalTime = [s.arrival]
                .filter(Boolean)
                .map(toLocalTime);
                line(`${header} ${arrivalTime} ${time ? ` (${time})` : ''}`, { bold: true, size: 13 });
                
                console.log("PICKUPS: ", s.pickups)
                if(s.pickups == 1){
                    line("Pickup")
                    if(s.locations && s.locations.length > 0){
                        console.log("LOCATIONS: ", s.locations)
                        for(const loc of s.locations){
                            console.log("LOCATION VALUE", loc)
                            const addr1 = loc.address1 ?? '';
                            const addr2 = loc.address2 ? `, ${loc.address2}` : '';
                            const csz = [loc.city, loc.state, loc.zipCode].filter(Boolean).join(', ');
                            const company = loc.companyName ? `${loc.companyName} — ` : '';
                            y -= 10
                            let addressText = `${company}${addr1}${addr2}${csz ? `, ${csz}` : ''}`;

                            const maxLen = 45;
                            const chunks = [];
                            let text = addressText.trim();
                            page.drawLine({
                                start: { x: 50, y },
                                end:   { x: 390, y },
                                thickness: 1,
                                dashPhase: 0,
                            });
                            while (text.length > maxLen) {
                                // find the last space before the 45th character
                                let splitIndex = text.lastIndexOf(' ', maxLen);

                                if (splitIndex === -1) {
                                splitIndex = maxLen;
                                }

                                chunks.push(text.slice(0, splitIndex).trim());

                                text = text.slice(splitIndex).trim();
                            }

                            if (text.length) chunks.push(text);

                            chunks.forEach(lineText => {
                                line(" " + lineText);
                            });

                            page.drawLine({
                                start: { x: 50, y: y - 5 },
                                end:   { x: 390, y: y - 5},
                                thickness: 1,
                                dashPhase: 0,
                            });

                            page.drawLine({
                                start: { x: 50, y: y - 5},
                                end:   { x: 50, y: y + lineH * chunks.length },
                                thickness: 1,
                                dashPhase: 0,
                            });

                            page.drawLine({
                                start: { x: 390, y: y - 5 },
                                end:   { x: 390, y: y + lineH * chunks.length },
                                thickness: 1,
                                dashPhase: 0,
                            });
                        }
                    }
                }

                const shipList = Array.isArray(s.shipments) ? s.shipments : [];
                if (shipList.length === 0 && s.pickups == null) {
                    line('Depot ' + s.waypoint);
                    y -= 6;
                    const w = page.getWidth();
                    page.drawLine({
                        start: { x: 50, y },
                        end:   { x: w - 50, y },
                        thickness: 1,
                        dashPhase: 0,
                    });
                    continue;
                }
                
                for (const sh of shipList) {
                    const id = sh?.shipmentID ?? '(no id)';
                    const a = sh?.address ?? {};
                    const addr1 = a.address1 ?? '';
                    const addr2 = a.address2 ? `, ${a.address2}` : '';
                    const csz = [a.city, a.state, a.zipCode].filter(Boolean).join(', ');
                    const company = a.companyName ? `${a.companyName} — ` : '';

                    const textTopY = y;
                    line(`Shipment ID:  ${id}`);
                    if(sh.signatureRequired){
                        page.drawText("Signature Required", {
                        x: 425,
                        y: y,
                        size: 10,
                        font: fontBold
                        });
                        y -= 10
                    }

                    if(sh.isPriority){
                        page.drawText("Priority", {
                        x: 425,
                        y: y,
                        size: 10,
                        font: fontBold
                        });
                        y -= 10
                    }
                    
                    y -= 10
                    let addressText = `${company}${addr1}${addr2}${csz ? `, ${csz}` : ''}`;

                    const maxLen = 45;
                    const chunks = [];
                    let text = addressText.trim();
                    page.drawLine({
                        start: { x: 50, y },
                        end:   { x: 390, y },
                        thickness: 1,
                        dashPhase: 0,
                    });
                    while (text.length > maxLen) {
                        // find the last space before the 45th character
                        let splitIndex = text.lastIndexOf(' ', maxLen);

                        if (splitIndex === -1) {
                        splitIndex = maxLen;
                        }

                        chunks.push(text.slice(0, splitIndex).trim());

                        text = text.slice(splitIndex).trim();
                    }

                    if (text.length) chunks.push(text);

                    chunks.forEach(lineText => {
                        line(" " + lineText);
                    });

                    page.drawLine({
                        start: { x: 50, y: y - 5 },
                        end:   { x: 390, y: y - 5},
                        thickness: 1,
                        dashPhase: 0,
                    });

                    page.drawLine({
                        start: { x: 50, y: y - 5},
                        end:   { x: 50, y: y + lineH * chunks.length },
                        thickness: 1,
                        dashPhase: 0,
                    });

                    page.drawLine({
                        start: { x: 390, y: y - 5 },
                        end:   { x: 390, y: y + lineH * chunks.length },
                        thickness: 1,
                        dashPhase: 0,
                    });

                    // Create PNG barcode
                    const pngBytes = await this.makePdf417PngBytes(id);
                    const img = await pdf.embedPng(pngBytes);

                    const targetW = 150;
                    const scale = targetW / img.width;
                    const drawW = targetW;
                    const drawH = img.height * scale;

                    // If not enough room left on page for the barcode height, move to a new page
                    if (textTopY - drawH - 6 < margin) {
                        page = pdf.addPage();
                        y = page.getHeight() - margin;
                    }

                    // Place barcode to the right
                    const rightX = page.getWidth() - margin - drawW;
                    page.drawImage(img, {
                        x: rightX,
                        y: y - drawH + (lineH * 1.5),
                        width: drawW,
                        height: drawH,
                    });

                    const textY = (y - drawH + (lineH * 1.5)) - 12;
                    page.drawText(`${id}`, {
                        x: rightX + 50,
                        y: textY + 3,
                        size: 10,
                        font
                    });

                    const textBlockH = lineH * 2 + 6;
                    const blockH = Math.max(textBlockH, drawH + 4);
                    y -= Math.max(0, blockH - (lineH * 2));
                    y -= 6;
                }

                y -= 8; // spacing between stops
                const w = page.getWidth();
                page.drawLine({
                    start: { x: 50, y },
                    end:   { x: w - 50, y },
                    thickness: 1,
                    dashPhase: 0,
                });
            }

            // Open in new tab
            const bytes = await pdf.save();
            const blob = new Blob([bytes], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);
            window.open(url);
        },
        async getRouteData(){
            let input = {
                input:{
                    routeCode: this.selectedRoute
                }
            }
            let queryRouteTable = `query getRoute{
            getRoute(routeCode: "${this.selectedRoute}") {
                    routeCode
                    openManifestAction
                    routeId
                    manifestCutoffTime
                }
            }
            `

            try{
                let queryRouteTableData = await API.graphql({
                query:  queryRouteTable,
                variables: input,
                authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                console.log("Route Data: ", queryRouteTableData.data.getRoute);
                this.selectedRouteObject = queryRouteTableData.data.getRoute;
            }catch(e){
                console.log(e)
                if(e){
                    this.toggleAlertBox = true;
                    this.alertMessage = "Error getting route data"
                }
            }
        },
        async manifestCreateTripFunc(){
            let manifestsToDespatchValue = "Open";
            this.loadingDespatch = true;

            let input = {
                input:{
                    routeId: this.selectedRouteObject.routeId,
                    manifestsToDespatch: [manifestsToDespatchValue]
                }
            }
            let manifestCreateTrip = `mutation manifestCreateTrip{
            manifestCreateTrip(input: {routeId: ${this.selectedRouteObject.routeId}, manifestsToDespatch: ["${manifestsToDespatchValue}"]}) {
                    tripSheetID
                }
            }
            `

            try{
                let manifestCreateTripData = await API.graphql({
                query:  manifestCreateTrip,
                variables: input,
                authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                console.log("manifestCreateTrip Data: ", manifestCreateTripData.data.manifestCreateTrip.tripSheetID);
                this.loadingDespatch = false;
                this.manifestTripSheetID = manifestCreateTripData.data.manifestCreateTrip.tripSheetID;
                this.manifestedSuccessfully = true;
                this.$router.push({
                    path: '/TripSheetDashboard',
                    query: { tripsheetid: manifestCreateTripData.data.manifestCreateTrip.tripSheetID } // => /TripSheetDashboard?tripsheetid=12345
                });
                return manifestCreateTripData.data.manifestCreateTrip.tripSheetID;
            }catch(e){
                console.log(e)
                if(e){
                    this.toggleAlertBox = true;
                    this.alertMessage = "Error getting manifestCreateTrip data"
                }
                this.loadingDespatch = false;
                this.manifestedSuccessfully = false;
                throw new Error("Manifest Create Trip Failed: ", e)
            }
        },
        async refreshMap(){
            await this.getManifestShipmentData()
            await this.getRouteData();
            if(this.manifestMapData.length > 0){
                if((this.manifestMapData[0].longitude != "")){
                    this.mapCreate();
                }
            }else{
                this.toggleAlertBox = true;
                this.alertMessage = "No manifest data available";
                this.selectedRoute = "";
            }
        },
        async selectRouteCode(event){
            this.manifestedSuccessfully = false;
            this.manifestTripSheetID = null;
            this.selectedRoute = "";
            this.isoDateTime = "";
            this.manifestMapData = []
            // this.isoDateTime = event.isoDateTime;
            console.log(event)
            this.selectedRoute = event.routeCode;
        },
        closeAlertBox(toggleAlertBox){
            this.toggleAlertBox = toggleAlertBox;
        },
        trackShipment(){
            this.toggleTrackShipment = true;
        },
        closeShipmentInfo(){
            this.toggleTrackShipment = false;
        },
        closeAddressSuggestion(){
            this.showDragAddressSuggestion = false;
        },
        async getManifestShipmentData(){
            this.loadingManifestData = true;
            this.manifestMapData = []

            let input = {
                input:{
                    route: this.selectedRoute
                }
            }

            let queryManifestWaypoint = `mutation queryManifestWaypoint($input: queryManifestWaypointInput!) {
                queryManifestWaypoint(input: $input) {
                    route
                    stop
                    longitude
                    latitude
                    route
                    waypoint
                    arrival
                    departure
                    geometry
                    stopType
                    isDelivery
                    windowEnd
                    windowStart
                    totalDistance
                    totalTime
                    created
                    startTime
                    endTime
                    pickups
                    locations{
                        address1
                        address2
                        latitude
                        longitude
                        city
                        companyName
                        zipCode
                        state
                    }
                    address{
                        address1
                        address2
                        latitude
                        longitude
                        city
                        companyName
                        zipCode
                        state
                      }
                    shipments{
                        shipmentID
                        isPriority
                        signatureRequired
                        lastActivity{
                            activityTime
                            description
                            code
                        }
                      address{
                        address1
                        address2
                        latitude
                        longitude
                        city
                        companyName
                        zipCode
                        state
                      }
                    }
                }
            }`

            try{
                let queryManifestWaypointData = await API.graphql({
                query:  queryManifestWaypoint,
                variables: input,
                authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                this.manifestMapData = [];
                this.manifestMapData = queryManifestWaypointData.data.queryManifestWaypoint;
                //console.log(this.manifestMapData)
                this.loadingManifestData = false;
            }catch(e){
                if(e){
                    this.toggleAlertBox = true;
                    this.alertMessage = "Error getting manifest data"
                    this.loadingManifestData = false;
                }
            }
        },
        formatLocalTimeArrival(time24) {
            if (typeof time24 !== 'string') return '';
            const [hours, minutes] = time24.split(":");
            const date = new Date();
            date.setHours(hours, minutes, 0, 0);

            // Format to a readable local 12-hour time
            const localTime = date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });

            return localTime;
        },
        async getLocationData(lng, lat){
            const credentials = await Auth.currentCredentials();

            const locationClient = new Location({
                credentials,
                region: 'us-east-1'
            });

            const params = {
                IndexName: "lrex-place",
                Position: [lng, lat],
                MaxResults: 5
            };

                locationClient.searchPlaceIndexForPosition(params,(err,data)=>{
                    if(err){
                        alert("Error with Location Services.")
                    }
                    if(data){
                        //Only suggest addresses with Street and AddressNumber Values
                        if(data.Results[0]){
                            if(data.Results[0].Place.AddressNumber || data.Results[0].Place.Street){
                                this.autoCompleteData = data.Results;
                                this.showDragAddressSuggestion = true;
                                console.log("Address from lat long: ", this.autoCompleteData[0].Place)
                            }
                        }
                    }
                })
        },
        mapCreate: function() {
                let mapCenter = null;
                let geometry = null;
         
                for (const location of this.manifestMapData) {
                    console.log("Inside for loop")
                    if (location.latitude !== null && location.longitude !== null) {
                        mapCenter = [location.longitude, location.latitude];
                    }

                    if (location.waypoint === "*") {
                        geometry = location.geometry;
                    }

                    if (mapCenter !== null && geometry !== null) {
                        break;
                    }
                }

                const map = new maplibregl.Map({
                    container: 'map',
                    style: 'LREXSite-Map',
                    center: mapCenter,
                    zoom: 10,
                    bearing: 64.8,
                    pitch: 10,
                    hash: true,
                    transformRequest: this.transformRequest
                });

                map.on('load', ()=>{
                    for (let i = 0; i < geometry.length; i++) {
                        const element = geometry[i];
                        console.log(element)
                        map.addSource('routeline' + i, {
                    type: 'geojson',
                    data: {
                        type: 'Feature',
                        properties: {},
                        geometry: {
                            type: 'LineString',
                            coordinates: element
                        }
                    }
                        })

                        map.addLayer({
                            id: 'routeline' + i,
                            type: 'line',
                            source: 'routeline' + i,
                            layout: {
                'line-join': 'round',
                'line-cap': 'round'
            },
            paint: {
                'line-color': '#000',
                'line-width': 4
            }
                        });
                }
                    }
                    )


                let markerArray = [];
                // markerArray.push(stopRecord)
                for (let i = 0; i < this.manifestMapData.length; i++) {
                    const element = this.manifestMapData[i];
                    let shipmentInfo = '';
                    element.shipments?.forEach((shipment) => {
                        shipmentInfo += `<h3 style="margin: 0;">Shipment ID: ${shipment.shipmentID}</h3>`;
                        shipmentInfo += `<p style="margin: 0;">Address: ${shipment.address.address1}, ${shipment.address.city}, ${shipment.address.state}, ${shipment.address.zipCode}</p>`;
                    })
                    const popup = new maplibregl.Popup({
                            offset: 15,
                    }).setHTML(
                            `
                            <div style="display: flex;
                            flex-direction: row;
                            align-items: center;
                            background-color: #e4e4e4;
                            border-radius: 999px;
                            padding: 5px;
                            width: -moz-fit-content;
                            width: fit-content;
                            margin-bottom: 5px;">
                            <svg style="width: 15px;
                            height: 15px;
                            padding-right: 5px;" id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 251.67 328.54" data-v-13454f0d=""><g id="_Ñëîé_1" data-name="Ñëîé 1" data-v-13454f0d=""><g data-v-13454f0d=""><g data-v-13454f0d=""><polyline class="cls-2-alt" points="213.95 310.25 213.95 280.72 192.99 240.34 66.07 240.34 45.11 284.23 45.11 310.25" data-v-13454f0d=""></polyline><line class="cls-2-alt" x1="48.63" y1="284.23" x2="213.95" y2="284.23" data-v-13454f0d=""></line><polyline class="cls-2-alt" points="150.64 284.23 150.64 323.54 129.53 314.13 108.43 323.54 108.43 284.23" data-v-13454f0d=""></polyline><line class="cls-2-alt" x1="115.46" y1="240.34" x2="108.43" y2="284.23" data-v-13454f0d=""></line><line class="cls-2-alt" x1="150.64" y1="284.23" x2="143.6" y2="240.34" data-v-13454f0d=""></line></g><path class="cls-2" d="M5,263.23l4.07-31.12c1.49-11.39,9.48-20.87,20.45-24.26l41.72-12.89c4.68-1.45,9.78-.46,13.58,2.62h0c23.9,19.38,58.11,19.38,82.01,0h0c3.81-3.09,8.9-4.07,13.58-2.62l41.72,12.89c10.97,3.39,18.97,12.87,20.45,24.26l4.07,31.12" data-v-13454f0d=""></path><path class="cls-2" d="M179.67,133.69v1.49c0,17.17-9.99,32.77-25.58,39.95l-16.31,7.52c-7.79,3.59-16.76,3.59-24.54,0l-16.31-7.52c-15.59-7.18-25.58-22.78-25.58-39.95v-1.49" data-v-13454f0d=""></path><path class="cls-2" d="M66.66,77.38l2.08-34.12c.68-11.22,7.8-21.02,18.25-25.15l28.02-11.08c6.83-2.7,14.44-2.7,21.28,0l28.02,11.08c10.45,4.13,17.56,13.94,18.25,25.15l2.08,34.12" data-v-13454f0d=""></path><path class="cls-2" d="M182.17,75.94l-.69-.59c-31.61-27.16-78.16-27.68-110.37-1.23l-1.41,1.16c-5.33,4.37-6.62,12-3.03,17.89l8.7,14.27h0c30.19-23.72,72.69-23.72,102.89,0h0s3.95-8.06,7.32-14.94c2.77-5.66,1.38-12.46-3.4-16.56Z" data-v-13454f0d=""></path><path class="cls-2" d="M57.76,116.69l-.15,.9c-1.37,8.44,5.15,16.11,13.7,16.11h.03" data-v-13454f0d=""></path><path class="cls-2" d="M193.24,116.69l.15,.9c1.37,8.44-5.15,16.11-13.7,16.11h0" data-v-13454f0d=""></path></g></g></svg>
                            <h3 style="margin: 0">Route: ${element.route}</h3>
                            </div>
                            <h3 style="text-align: left; margin-bottom: 2.5px; margin-top: 2.5px;">Stop #: ${element.stop}</h3>
                            <p style="text-align: left; margin: 0;">Arrival Time: ${this.formatLocalTimeArrival(element.arrival)}</p>
                            <p style="text-align: left; margin: 0;">Departure Time: ${this.formatLocalTimeArrival(element.departure)}</p>
                            <div style="
                            max-height: 100px;
                            overflow-y: scroll;
                            text-align: left;
                            ">
                            ${shipmentInfo}
                            </div>
                            `
                    );

                    //stopType
                    //0 = Order (delivery or pickup)
                    //1 = Depot
                    //2 = Break
                    //isDelivery indicates if stop is pickup or delivery
                    //Priority is some comparison of time windows
                    let markerColor;
                    let deliveryColor = "#32ccfe";
                    let pickupColor = "#33f18a";
                    let depotColor = "#fe804d";
                    let breakColor = "#000000"

                    if(element.isDelivery == true && element.stopType == 0){
                        markerColor = deliveryColor;
                    }else if(element.isDelivery == false && element.stopType == 0){
                        markerColor = pickupColor;
                    }else if(element.stopType == 1){
                        markerColor = depotColor;
                    }else if(element.stopType == 2){
                        markerColor = breakColor;
                    }

                    if(!element.stop){
                        continue;
                    }

                    const svgString = `
                    <svg xmlns="http://www.w3.org/2000/svg" overflow="visible" width="25" height="36" viewBox="0 0 24 32">
                    <g transform="translate(1.75, 28.0)" fill="#000000"><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="10.5" ry="5.25002273"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="10.5" ry="5.25002273"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="9.5" ry="4.77275007"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="8.5" ry="4.29549936"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="7.5" ry="3.81822308"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="6.5" ry="3.34094679"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="5.5" ry="2.86367051"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="4.5" ry="2.38636864"></ellipse></g>
                    <path stroke="#000" stroke-width="1" fill="${markerColor}" d="M12,0c-6.6,0-12,5.4-12,12c0,10,12,20,12,20s12-10,12-20C24,5.4,18.6,0,12,0z M12,15c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S13.7,15,12,15z"/>
                    <circle stroke="${markerColor}" stroke-width="1" cx="12" cy="12" r="10.5" fill="${markerColor}"/>
                    <text x="50%" y="45%" text-anchor="middle" fill="#000" font-size="12" dy=".3em" font-weight = "bold">${element.stop}</text>
                    </svg>
                    `;

                    // Create a new div element and set its innerHTML to the SVG string
                    const svgElement = document.createElement('div');
                    svgElement.innerHTML = svgString;
                    
                    let mapMarker = 
                    new maplibregl.Marker({
                        color: markerColor,
                       element: svgElement
                    }).setLngLat([element.longitude, element.latitude])
                    .setPopup(popup)
                    .addTo(map);

                    markerArray.push(mapMarker)
                }

                // let boundingArray = []
                // for (let i = 0; i < markerArray.length; i++) {
                //     const element = markerArray[i];
                //     boundingArray.push([element['_lngLat'].lng, element['_lngLat'].lat])
                // }

                // if (boundingArray.length > 0) {
                //     map.fitBounds(boundingArray, {padding: 50})
                // }
                const bounds = new maplibregl.LngLatBounds();

                for (const m of markerArray) {
                    const { lng, lat } = m.getLngLat();
                    bounds.extend([lng, lat]);
                }

                // 2) Guard single-marker case
                if (markerArray.length === 1) {
                    map.easeTo({ center: bounds.getCenter(), zoom: 14 });
                    } else if (!bounds.isEmpty()) {
                    // 3) If you have side panels or a bottom bar, pad appropriately
                    map.resize(); // if the container just changed size
                    map.setPitch(0); // optional: flatten to get a tighter fit
                    map.setBearing(0); // optional
                    map.fitBounds(bounds, {
                        padding: { top: 60, right: 60, bottom: 120, left: 60 },
                        maxZoom: 15,   // prevents zooming in too tight
                        duration: 0    // instant; or use 500 for animation
                    });
                }

                map.addControl(new maplibregl.NavigationControl());
            },
            transformRequest: function (url, resourceType) {
                if (resourceType === 'Style' && !url.includes('://')) {
                    url = `https://maps.geo.${AWS.aws_project_region}.amazonaws.com/maps/v0/maps/${url}/style-descriptor`
                }
                if (url.includes('amazonaws.com')) {
                    return {
                        url: Signer.signUrl(url, {
                            access_key: this.credentials.accessKeyId,
                            secret_key: this.credentials.secretAccessKey,
                            session_token: this.credentials.sessionToken,
                        }),
                    }
                }
                return { url }
            },
            async listRouteData(){
                let graphqlQuery = `query listRoutes{
                    listRoutes(limit: 300){
                        items{
                            routeCode
                            }
                        }
                    }`
                
                try{
                    let listRouteDataReturn = await API.graphql({
                    query:  graphqlQuery,
                    authMode: "AMAZON_COGNITO_USER_POOLS",
                    })
                    
                    this.routeTableData = listRouteDataReturn.data.listRoutes.items;
                }catch(e){
                    console.log(e)
                    if(e){
                        this.toggleAlertBox = true;
                        this.alertMessage = "Error getting route codes"
                    }
                }
            }
    }
}
</script>

<style scoped>
/* @import 'node_modules/maplibre-gl/dist/maplibre-gl.css'; */
body { margin: 0; }
#map { 
    height: 60vh; 
    border-radius: 25px;
}

select{
    padding: 10px;
    font-size: 15px;
    border: 1px solid rgba(0,0,0,.336);
    border-radius: 15px;
    outline: none;
    margin-top: 5px;
    margin-bottom: 5px;
}

.svg-container-outer{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}

.svg-container{
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    width: fit-content;

    background-color: #fff;
    padding: 15px;
    border-radius: 25px;
    margin: 10px;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}

.svg-container h3{
    margin: 0;
}

.svg-inner-container{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    max-width: 100px;
}

.svg-inner-container p{
    margin: 0;
}

.svg-inner-container svg{
    margin-left: 5px;
}

.time-distance{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    width: fit-content;
    background-color: #fff;
    padding: 15px;
    border-radius: 25px;
    flex-basis: 25%;
    margin: 10px;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}

.time-distance-inner{
    display: flex;
  align-items: center;
  width: 100%;
}

.label {
  margin: 0;
  font-weight: 500;
  color: #666;
  flex: 0 0 auto;
}

.value {
    margin: 0;
    font-weight: 600;
    margin-left: auto; /* push value all the way right */
    white-space: nowrap; /* 🔑 PREVENT WRAP */
    text-align: right;
}

.route-info{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: fit-content;
    background-color: #fff;
    padding: 15px;
    border-radius: 25px;
    flex-basis: 25%;
    margin: 10px;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}

.manifest-header{
    text-align: left;
    background-color: #e4e4e4;
    width: fit-content;
    padding: 5px;
    border-radius: 999px;
    /* margin-bottom: 5px !important; */
    /* margin-top: 0; */
 }

.button-container-main{
    display: flex;
    flex-direction: column;
    min-height: 100%;
}

.button-container-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}

.bottom-button{
    margin-top: 20px;
}

 .print-button{
    background-color: #e4e4e4;
    color: #000;
    border: none;
    border-radius: 999px;
    padding: 5px 15px;
    width: fit-content;
    height: fit-content;
    margin-left: 25px;
    /* margin-top: 5px; */
    margin-bottom: 5px;
    transition-duration: .5s;
    cursor: pointer;
}

.print-button:hover{
    transition-duration: .5s;
    background-color: #d5d5d5;
}

.refresh-button{
    margin-right: 5px;
    background-color: #32ccfe;
    border: none;
    padding: 5px;
    border-radius: 99px;
    color: white;
    transition-duration: .25s;
    cursor: pointer;
}

.refresh-button:hover{
    transition-duration: .25s;
    filter: brightness(0.95);
}

.optimize-manifest-button{
    background-color: #fe804d;
    margin-left: 15px;
    border: none;
    padding: 5px;
    border-radius: 99px;
    color: white;
    transition-duration: .25s;
    cursor: pointer;
}

.optimize-manifest-button:hover{
    transition-duration: .25s;
    filter: brightness(0.95);
}

.update-shipment{
    background-color: #32ccfe;
    border: none;
    padding: 5px;
    border-radius: 99px;
    color: white;
}

.despatch-info-container{
    background-color: #fff;
    padding: 15px;
    border-radius: 25px;
    flex-basis: 25%;
    margin: 10px;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.manifest-text-container{
    display: flex;
    justify-content: flex-start;
 }

 .manifest-text-container h3{
    margin-top: 5px;
    margin-bottom: 5px;
    background-color: #e4e4e4;
    padding: 5px;
    border-radius: 999px;
 }

 .manifest-text-container p{
    margin-top: 5px;
    margin-bottom: 5px;
 }

.alert-container{
        width: 100%;
        height: 100vh;
        display: flex;
        justify-content: center;
        position: absolute;
        z-index: 99;
        left: 0;
        right: 0;
        top: 0;
        background: linear-gradient(rgba(0, 0, 0, 0.15) 0%, rgba(0, 0, 0, 0.15) 90%, rgba(236, 236, 236, 0.05) 100%);
    }

    .inner-container{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
    }

    .main-button-blue-white{
        margin: 5px;
        padding-top: 4px;
        padding-bottom: 4px;
    }

    .text-container{
        background-color: #fff;
        box-shadow: 0 0 20px rgba(0, 0, 0, 0.475);
        border-radius: 15px;
        width: 30%;
        z-index: 99;
        text-align: center;
        position: absolute;
        top: 15%;
        animation: animate-alert .5s ease;
        max-height: 70vh;
        overflow-y: auto;

    }

    .header-container{
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        background-color: #e4e4e4;
        border-radius: 999px;
        padding: 5px;
        width: -moz-fit-content;
        width: fit-content;
        text-align: center;
    }

    .header-outer-container{
        width: 100%;
        display: flex;
        justify-content: center;
        margin-top: 5px;
    }

    .cancel-button{
        margin: 5px;
        background-color: #fe804d;
        color: #fff;
        border-radius: 15px;
        padding: 5px 10px;
        border: none;
        cursor: pointer;
        transition-duration: .25s;
    }

    .cancel-button:hover{
        background-color: #d26a41;
        transition-duration: .25s;
    }

    @keyframes animate-alert {
        from{
            top: 10%;
            opacity: 0;
        }
        to{
            top: 15%;
            opacity: 1;
        }
    }

    @media screen and (max-width: 1000px) {
        .text-container{
            width: 70%;
        }

        .svg-container-outer{
            flex-direction: column;
        }

        .optimize-manifest-button{
            margin-left: 0px;
            margin-top: 5px;
            margin-bottom: 5px;
        }
    }
</style>